/* eslint-disable @typescript-eslint/no-explicit-any */
import Qs from 'qs'
import service from '@/services/service'
import { APIProductKeyword } from '@/models/api/product-keyword.model'

const resource = {
    main: 'services',
    module: 'product-keywords'
}

export class ProductKeywordsServices {
    public static getProductKeywords () {
        return service.get(`${resource.main}/${resource.module}`)
    }

    public static getProductKeywordsPaginate (params: object) {
        return service.get(`${resource.main}/${resource.module}/paginate`, {
            params,
            paramsSerializer: (params) => {
                return Qs.stringify(params, { arrayFormat: 'indices' })
            }
        })
    }

    public static getProductKeywordsById (id: number) {
        return service.get(`${resource.main}/${resource.module}/${id}`)
    }

    public static createProductKeywords (params: APIProductKeyword) {
        return service.post(`${resource.main}/${resource.module}`, params)
    }

    public static editProductKeywords (params: APIProductKeyword) {
        return service.put(`${resource.main}/${resource.module}/${params.productKeywordId}`, params)
    }

    public static deleteProductKeywords (id: number) {
        return service.delete(`${resource.main}/${resource.module}/${id}`)
    }

    public static restoreProductKeywords (id: number) {
        return service.put(`${resource.main}/${resource.module}/restore/${id}`)
    }
}
